import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_filter_and_search = _resolveComponent("filter-and-search")!
  const _component_templates_table = _resolveComponent("templates-table")!
  const _component_base_table_panel = _resolveComponent("base-table-panel")!

  return (_openBlock(), _createBlock(_component_base_table_panel, {
    id: "template-panel",
    loading: _ctx.loading,
    onPaginate: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('paginate')))
  }, {
    default: _withCtx(() => [
      _createVNode(_component_filter_and_search, {
        config: _ctx.config,
        onPerPageChanged: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('paginate')))
      }, null, 8, ["config"]),
      _createVNode(_component_templates_table, { kind: _ctx.currentKind }, null, 8, ["kind"])
    ]),
    _: 1
  }, 8, ["loading"]))
}